module.exports = __webpack_public_path__ + "PlusJakartaSans-Bold.woff";